import { createFileRoute, notFound } from "@tanstack/react-router";
import { PeopleNotFound } from "@/components/marketing/site/people-not-found";

// A real 404, not a redirect (a redirect reads as a soft 404 to crawlers). On ppl-ai.com every
// unknown address lands here via lib/host-rewrite.ts. Only the router sets the response status,
// so the loader throws `notFound()`; the title and `noindex` ride in `head()`.
export const Route = createFileRoute("/v2/$")({
  loader: () => {
    throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Page not found | PEOPLE AI Workforce" },
      { name: "robots", content: "noindex" },
    ],
  }),
  notFoundComponent: () => <PeopleNotFound />,
  component: () => <PeopleNotFound />,
});
